angular
	.module('MyApp')
	.service('CobrancaService', ['$resource','$q','SessionData','Configs', 'DownloadArquivo',
		function($resource, $q, SessionData, Configs, DownloadArquivo) {
			var _msgErro = {
			msgErro : 'Error cobranca não encontrada'
			};

			function dadosValidosAluno(){
				if(SessionData.aluno){
					dadosAluno = {
						aluno: SessionData.aluno.list[SessionData.aluno.selecionado].codAluno,
						pessoa: SessionData.aluno.list[SessionData.aluno.selecionado].id
					};
					return true;
				}
				return false;
			}

			this.listarItensCobranca = function(cobranca, codAluno) {
				let defer = $q.defer();
				var codigoCobranca = {
					'cod_cobranca' : cobranca,
          'cod_aluno': codAluno
					}

				$resource(
					Configs.getApiServer() + '/financeiro/aluno/:cod_aluno/cod_cobranca/:cod_cobranca/obter_lista_itens_cobranca', {}, {
						cache : false,
						query : {
							method : 'GET'
						}
				}).query(codigoCobranca, function(result) {
					defer.resolve(result);
				}, function(err) {
					defer.reject(err);
				});

				return defer.promise;
			}

	this.getDadosImpressaoBoleto = function(codBoleto) {
		let defer = $q.defer();
		var codigoCobranca = {
			'cod_boleto' : codBoleto,
			'codPessoa': SessionData.user.id
			}

		$resource(
			Configs.getApiServer() + '/financeiro/cod_boleto/:cod_boleto/codPessoa/:codPessoa/obtem_dados_impressao_boleto', {}, {
				cache : false,
				query : {
					method : 'GET'
				}
		}).query(codigoCobranca, function(result) {
			defer.resolve(result);
		}, function(err) {
			defer.reject(err);
		});

		return defer.promise;
	}

	this.getExibeProrrogaBoleto = function(codBoleto) {
		let defer = $q.defer();
		if (dadosValidosAluno()){
			dadosAluno.boleto = codBoleto;
			$resource(
				Configs.getApiServer() + '/financeiro/aluno/:aluno/pessoa/:pessoa/boleto/:boleto/exibe_prorroga_boleto', {}, {
					cache : false,
					query : {
						method : 'GET',
						isArray: false
					}
			}).query(dadosAluno, function(result) {
				defer.resolve(result);
			}, function(err) {
				defer.reject(err);
			});
		} else {
			defer.reject({
				_msgErro
			});
		}

		return defer.promise;
	}

	this.prorrogarVencimentoBoleto = function(codBoleto) {
		let defer = $q.defer();
		if (dadosValidosAluno()){
			let params = {
				cod_boleto_antigo: codBoleto,
				cod_aluno: dadosAluno.aluno
			}
			$resource(
				Configs.getApiServer() + '/financeiro/cod_boleto_antigo/:cod_boleto_antigo/cod_aluno/:cod_aluno/prorroga_vencimento_boleto', {}, {
					cache : false,
					query : {
						method : 'GET',
						isArray: false
					}
			}).query(params, function(result) {
				defer.resolve(result);
			}, function(err) {
				defer.reject(err);
			});
		} else {
			defer.reject({
				_msgErro
			});
		}

		return defer.promise;
	}

	this.downloadBoletoCobranca = function(codBoleto) {
		let params = {};
		params.url = Configs.getApiServer() + '/financeiro/cod_aluno/' + encodeURI(dadosAluno.aluno) + '/cod_boleto/' + codBoleto + '/exibir_arquivo/false/download_boleto';
		params.type = 'application/pdf';
		params.nomeArquivo = 'Boleto_' + codBoleto + '_' + new Date().getTime();
		params.method = "GET";

		DownloadArquivo.downloadArquivo(params);
	}

	this.downloadBoletoCobrancaV2 = function(codBoleto, codAluno) {
		if(!codBoleto || !codAluno){
			$ionicLoading.hide();
			return;
		}

		let params = {};
		params.url = Configs.getApiServer() + '/financeiro/cod_aluno/' + encodeURI(codAluno) + '/cod_boleto/' + codBoleto + '/exibir_arquivo/false/download_boleto';
		params.type = 'application/pdf';
		params.nomeArquivo = 'Boleto_' + codBoleto + '_' + new Date().getTime();
		params.method = "GET";

		DownloadArquivo.downloadArquivo(params);
	}

	this.listarItensDetalheBoleto = function(codBoleto, codAluno) {
		let defer = $q.defer();
		var codigoCobranca = {
			'cod_boleto' : codBoleto,
      'cod_aluno': codAluno
			}

		$resource(
			Configs.getApiServer() + '/financeiro/aluno/:cod_aluno/cod_boleto/:cod_boleto/lista_itens_detalhe_boleto', {}, {
				cache : false,
				query : {
					method : 'GET',
	                isArray: true
				}
		}).query(codigoCobranca, function(result) {
			defer.resolve(result);
		}, function(err) {
			defer.reject(err);
		});

		return defer.promise;
	}

	this.downloadBoletoAlunoToken = function(token) {
		if(!token){
			$ionicLoading.hide();
			return;
		}

		let params = {};
		params.url = Configs.getApiServer() + '/comum/boleto-aluno-token';
		params.type = 'application/pdf';
		params.nomeArquivo = 'Boleto_' + new Date().getTime();
		params.method = "GET";
		params.params={token}

		DownloadArquivo.downloadArquivo(params);
	}
	this.downloadBoletoCandidatoToken = function(token) {
		if(!token){
			$ionicLoading.hide();
			return;
		}

		let params = {};
		params.url = Configs.getApiServer() + '/comum/boleto-candidato-token';
		params.type = 'application/pdf';
		params.nomeArquivo = 'Boleto_candidato_' + new Date().getTime();
		params.method = "GET";
		params.params={token}

		DownloadArquivo.downloadArquivo(params);
	}
}]);
